/* global axios */

const DEFAULT_API_VERSION = 'v1';

class ApiClient {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const isInsideAccountScopedURLs =
      window.location.pathname.includes('/app/accounts');

    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }

    return '';
  }

  baseUrl() {
    let url = this.apiVersion;

    if (this.options.enterprise) {
      url = `/enterprise${url}`;
    }

    if (this.options.accountScoped && this.accountIdFromRoute) {
      url = `${url}/accounts/${this.accountIdFromRoute}`;
    }

    return url;
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    // Detectar si hay archivos en los datos
    const hasFiles = this.hasFileData(data);

    if (hasFiles) {
      const formData = this.buildFormData(data);

      return axios.post(this.url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }

    return axios.post(this.url, data);
  }

  hasFileData(obj) {
    if (!obj || typeof obj !== 'object') return false;

    return Object.values(obj).some(value => {
      if (value instanceof File || value instanceof Blob) {
        return true;
      }
      if (Array.isArray(value)) {
        return value.some(item => item instanceof File || item instanceof Blob);
      }
      if (typeof value === 'object' && value !== null) {
        return this.hasFileData(value);
      }
      return false;
    });
  }

  buildFormData(data, formData = new FormData(), prefix = '') {
    Object.entries(data).forEach(([key, value]) => {
      const fieldName = prefix ? `${prefix}[${key}]` : key;

      if (value instanceof File || value instanceof Blob) {
        formData.append(fieldName, value);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (item instanceof File || item instanceof Blob) {
            formData.append(`${fieldName}[]`, item);
          } else if (typeof item === 'object' && item !== null) {
            this.buildFormData(item, formData, `${fieldName}[${index}]`);
          } else {
            formData.append(`${fieldName}[]`, item);
          }
        });
      } else if (typeof value === 'object' && value !== null) {
        this.buildFormData(value, formData, fieldName);
      } else if (value !== null && value !== undefined) {
        formData.append(fieldName, value);
      }
    });
    return formData;
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default ApiClient;
